var mAppLangage = "";
var mCurrency = "usd"; // usd krw
export function initLang(langObj) {
    var userLang = (navigator.language || navigator.userLanguage).toLowerCase().substring(0, 2); 
    if (userLang =="ko") { //한국어라면
        mAppLangage = 'ko';
        langObj.locale = mAppLangage;
    } else { //그 외~
        mAppLangage = 'en';
        langObj.locale = mAppLangage;
    }
}
export function getLang() {
    return mAppLangage;
}
export function setLang(lang, langObj) {
    mAppLangage = lang;
    langObj.locale = mAppLangage;
}
// krw usd
export function getCurrency() {
    if(mAppLangage == 'ko') return 'krw';
    if(mAppLangage == 'en') return 'usd';
}